export enum PlayerAction {
  // players for Account and Customers
  REPLACE_CUSTOMERS_PLAYERS = "REPLACE_CUSTOMERS_PLAYERS",
  // exclude players from team avg
  EXCLUDE_PLAYERS = "EXCLUDE_PLAYERS",
  //Update Live SPeeds
  UPDATE_LIVE_SPEEDS = "UPDATE_LIVE_SPEEDS",
  // exclude players by period/session
  SET_EXCLUDE_PLAYERS_BY_PERIOD = "SET_EXCLUDE_PLAYERS_BY_PERIOD",
}

export type CustomerPlayersType ={
    esbId?: string,
    jerseyNumber: string,
    key: string,
    name: string,
    position: string,
    positionGroup: string,
    rollinMax: number | string,
    speed: number | string,
    status: string
}
export type NId = {
    name:string,
    max:number | string,
    maxS: number | string
}
export type LiveSpeedsLog ={
teamId: string;
dsid: string;
nids: NId[]
}

export interface ExcludePlayers{  
        type: PlayerAction.EXCLUDE_PLAYERS,
        gameId: string,
        playersExcluded: string[]
};

export interface ReplaceCustomerPlayers {
    type: PlayerAction.REPLACE_CUSTOMERS_PLAYERS,
    teamId: string,
    customerPlayers: CustomerPlayersType[]
};

export interface SetLiveSpeedsLog {
    type: PlayerAction.UPDATE_LIVE_SPEEDS,
    liveSpeedsData: LiveSpeedsLog[]
};

export type PlayersExcludedByPeriodType = Record<string, number[]>;

export interface SetPlayersExcludedByPeriod {
  type: PlayerAction.SET_EXCLUDE_PLAYERS_BY_PERIOD,
  playersExcludedByPeriod: PlayersExcludedByPeriodType[]
};

export type PlayerActions = | ExcludePlayers | ReplaceCustomerPlayers | SetLiveSpeedsLog | SetPlayersExcludedByPeriod;